<template>
  <flex class="align-center">
    <icon v-if="event.complete" icon="check" class="has-text-success" />
    <icon v-else icon="circle" type="far" />
    <span class="ml" :class="event.complete ? 'has-text-white has-text-weight-medium' : ''">
      {{ event.complete ? event.complete_description : event.pending_description }}
    </span>
  </flex>
</template>

<script>
import { PipelineEvent } from './pipeline-event'

export default {
  props: {
    event: {
      type: PipelineEvent,
      required: true
    }
  }
}
</script>
